import Swiper, { Navigation, Pagination, Autoplay, EffectFade } from 'swiper';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);

export function Carousel() {
    new Swiper(".carousel", {
        loop: true,
        pagination: false,
        autoplay: {
            delay: 5000
        },
        effect: 'fade'
    });
}
